export const JSON_BODY_HEADER = {
  "Content-Type": "application/json",
};
